import { render, staticRenderFns } from "./FiscalDocuments.vue?vue&type=template&id=4184b21a&scoped=true"
import script from "./FiscalDocuments.vue?vue&type=script&lang=ts"
export * from "./FiscalDocuments.vue?vue&type=script&lang=ts"
import style0 from "./FiscalDocuments.vue?vue&type=style&index=0&id=4184b21a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4184b21a",
  null
  
)

export default component.exports